module.exports = __webpack_public_path__ + "img/41.73c6a687.png";